import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography } from '@metarouter-private/mr-mui';

import { AceCodeEditor } from '@ion/components';
import CopyToClipboard from 'app/components/CopyToClipboard';

const SECTION_TITLE = 'Request Body';

export default function RequestBody({ value }) {
  return (
    <Stack mt={4} spacing={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{SECTION_TITLE}</Typography>

        <CopyToClipboard text={value} />
      </Stack>

      <AceCodeEditor foldable rows={30} name="request-drawer-body" readOnly lang="json" value={value} />
    </Stack>
  );
}

RequestBody.propTypes = {
  value: PropTypes.string.isRequired,
};
